// components/shared/Card.jsx
export function Card({
  children,
  className = "",
  primaryColor = "#ea580c",
  title,
  subtitle,
  actions,
}) {
  return (
    <section
      className={`bg-slate-900/50 backdrop-blur-sm border rounded-2xl p-6 shadow-xl ${className}`}
      style={{ borderColor: `${primaryColor}20` }}
    >
      {(title || subtitle || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
          <div>
            {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
            {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
          </div>
          {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
